import React from "react";

const FlagshipProductsSection = ({ products, navigateTo }) => {
  return (
    <section className="flagship-products-section py-5">
      <div className="container bg-white p-4 rounded overflow-hidden">
        <h2 className="text-center fw-bold mb-5 text-black">
          Our Flagship Products
        </h2>
        <div className="row g-4">
          {products.map((product, index) => (
            <div className="col-md-4" key={index}>
              <div className="slide-in-left h-100">
                <div className="card flagship-card shadow-sm h-100 border-0">
                  <div className="flagship-image-wrapper">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="img-fluid"
                    />
                  </div>
                  <div className="card-body">
                    <h5 className="fw-bold">{product.title}</h5>
                    <p className="text-muted">{product.description}</p>
                    <ul className="list-unstyled">
                      {product.features.map((feature, i) => (
                        <li key={i}>
                          <i className="bi bi-check2 me-2"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => navigateTo(product.route)}
                      style={{
                        backgroundColor: "#020248",
                        color: "white",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        fontSize: "15px",
                        border: "0 solid transparent",
                        textDecoration: "none",
                        display: "inline-block",
                      }}
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FlagshipProductsSection;
